import type { CityConfig } from "../city-template/types";

export const covingtonConfig: CityConfig = {
  city: "Covington",
  state: "Kentucky",
  stateAbbr: "KY",
  slug: "covington",
  route: "/cities/covington",
  title: "Emergency Passport Covington, KY | Fast Passport Renewal | Cincinnati Metro",
  metaDescription: "Emergency passport and expedited passport services in Covington, KY — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Kenton County, Northern Kentucky, and Cincinnati metro travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Covington, KY",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Covington and Northern Kentucky travelers get their expedited passports as quickly as 24 hours. Serving the Cincinnati metro area, Ohio River communities, and cross-border travelers. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Covington%20Kentucky%20downtown%20skyline%20with%20Ohio%20River%20and%20Cincinnati%20skyline%20in%20the%20background%2C%20Roebling%20Suspension%20Bridge%20visible%20connecting%20Kentucky%20to%20Ohio%2C%20historic%20riverside%20buildings%20with%20warm%20evening%20sunset%20light%2C%20clean%20panoramic%20cityscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20Northern%20Kentucky%20cityscape%20with%20Ohio%20River%20waterfront%20and%20modern%20developments%2C%20wide%20panoramic%20view&width=1800&height=700&seq=covington-hero-001&orientation=landscape",
  heroImageAlt: "Covington Kentucky downtown skyline with Ohio River and Cincinnati in the background at sunset",
  geoPosition: "39.0837;-84.5086",
  geoPlacename: "Covington, Kentucky",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "77 W Jackson Blvd, Suite 1200, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 300 miles from Covington via I-74 and I-65",
  },
  nearbyCitiesZips: [
    { name: "Covington", zips: "41011, 41012, 41014, 41015, 41016, 41017, 41018, 41019" },
    { name: "Newport", zips: "41071, 41072, 41075, 41076, 41099" },
    { name: "Florence", zips: "41022, 41042, 41043, 41044" },
    { name: "Fort Thomas", zips: "41075, 41076" },
    { name: "Erlanger", zips: "41018, 41017, 41051" },
    { name: "Independence", zips: "41051, 41052, 41053, 41054, 41055, 41056, 41057, 41058, 41059, 41060, 41061, 41062, 41063, 41064, 41065, 41066, 41067, 41068, 41069, 41070, 41071, 41072, 41073, 41074, 41075, 41076, 41077, 41078, 41079, 41080, 41081, 41082, 41083, 41084, 41085, 41086, 41087, 41088, 41089, 41090, 41091, 41092, 41093, 41094, 41095, 41096, 41097, 41098, 41099" },
    { name: "Fort Mitchell", zips: "41011, 41017, 41051" },
    { name: "Edgewood", zips: "41017, 41018, 41051" },
    { name: "Park Hills", zips: "41011, 41017, 41075" },
    { name: "Ludlow", zips: "41016, 41099" },
    { name: "Bellevue", zips: "41073, 41074" },
    { name: "Dayton", zips: "41074, 41073, 41075, 41076, 41099" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Cincinnati metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Florence", route: "/cities/florence" },
    { name: "Fast passport renewal in Louisville", route: "/cities/louisville" },
    { name: "Emergency passport help in Lexington", route: "/cities/lexington" },
    { name: "Urgent passport services in Bowling Green", route: "/cities/bowling-green" },
    { name: "Same-day passport help in Newport", route: "/cities/newport" },
    { name: "Passport courier services near Erlanger", route: "/cities/erlanger" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Covington remotely via secure courier. We do not have a walk-in office in Covington — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Kenton County travelers.",
  fpcOfficeDistance: "Serving all of Kenton County and the Northern Kentucky Cincinnati metro area",
  serviceAreaIntro: "From downtown Covington to the historic Licking Riverside district, from the Devou Park area to the cross-river Cincinnati connections — Fast Passport Center serves the entire Northern Kentucky community. We regularly help travelers from Newport, Florence, and Fort Thomas get their passports fast.",
  nearbyCitiesIntro: "We serve all Covington neighborhoods and nearby Northern Kentucky cities including Newport, Florence, Fort Thomas, Erlanger, Independence, Fort Mitchell, Edgewood, Park Hills, Ludlow, Bellevue, and Dayton. If you are in Kenton County, Northern Kentucky, or the Cincinnati metro area, we have you covered.",
  howItWorksIntro: "Most Covington travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Covington travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Covington and Northern Kentucky travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Covington? Here are the most common ones we hear from Kenton County travelers.",
  statePageRoute: "/states/kentucky",
  statePageName: "Kentucky",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "3–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Kenton County international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Catherine D.",
      location: "Covington, KY",
      rating: 5,
      text: "I had a business trip to Toronto in 4 days and my passport was expired. Fast Passport Center renewed it in 36 hours. They even helped me find a photo location near the Roebling Bridge. Outstanding service.",
      service: "Passport Renewal",
    },
    {
      name: "Mark S.",
      location: "Newport, KY",
      rating: 5,
      text: "Our family planned a European vacation for years and my wife's passport was lost. They got her an emergency replacement in 2 days. We made our flight to London from CVG. Thank you for saving our trip.",
      service: "Lost Passport",
    },
    {
      name: "Laura P.",
      location: "Fort Thomas, KY",
      rating: 5,
      text: "Emergency medical situation in Canada required immediate travel. Fast Passport Center processed my passport in 24 hours. Their courier service is a lifesaver for Northern Kentucky residents.",
      service: "Emergency Passport",
    },
    {
      name: "James R.",
      location: "Florence, KY",
      rating: 5,
      text: "I needed a new passport for a Caribbean cruise out of Miami. I was nervous about the timeline but they delivered in 5 days. Professional, fast, and they answered every question I had.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "covington-1",
      name: "Covington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "700 W 5th St",
      city: "Covington",
      state: "KY",
      zip: "41011",
      phone: "(859) 261-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Covington",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Kenton County. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "covington-2",
      name: "Newport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 W 10th St",
      city: "Newport",
      state: "KY",
      zip: "41071",
      phone: "(859) 291-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Newport",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Campbell County residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "covington-3",
      name: "Kenton County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "303 Court St",
      city: "Covington",
      state: "KY",
      zip: "41011",
      phone: "(859) 392-1400",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from Kenton County Courthouse",
      website: "https://www.kentoncountyky.gov/",
      websiteLabel: "Kenton County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "covington-4",
      name: "Florence Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7100 Turfway Rd",
      city: "Florence",
      state: "KY",
      zip: "41042",
      phone: "(859) 371-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Florence",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Boone County. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "covington-5",
      name: "Erlanger Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3130 Dixie Hwy",
      city: "Erlanger",
      state: "KY",
      zip: "41018",
      phone: "(859) 727-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from Erlanger center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Kenton County residents. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "covington-6",
      name: "Fort Thomas Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "24 S Fort Thomas Ave",
      city: "Fort Thomas",
      state: "KY",
      zip: "41075",
      phone: "(859) 441-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from Fort Thomas center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Campbell County residents. Convenient for Fort Thomas area.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Cincinnati metro photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Kenton County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Covington applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Kenton County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Northern Kentucky travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Covington." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Covington address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Covington before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Covington for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Covington?", a: "Fast Passport Center offers fast passport renewal in Covington in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. Many cruise lines require your passport to be valid for at least 6 months beyond your travel date. We can expedite your passport renewal in Covington in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Covington?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 5 hour drive from Covington — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Kenton County residents." },
    { q: "Can I expedite a child passport in Covington?", a: "Yes. Fast Passport Center expedites child passports in Covington for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Kenton County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Covington with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Covington?", a: "With Fast Passport Center's emergency courier service, Covington travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Covington?", a: "Popular options include the Covington Post Office (41011), Newport Post Office (41071), Kenton County Clerk (41011), Florence Post Office (41042), Erlanger Post Office (41018), and Fort Thomas Post Office (41075). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Covington?", a: "Same-day passports are only available at the Chicago Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 5 hour drive to Chicago." },
    { q: "What if I live in the Cincinnati metro area?", a: "We serve the entire Northern Kentucky Cincinnati metro including Newport, Florence, Fort Thomas, Erlanger, Independence, Fort Mitchell, Edgewood, Park Hills, Ludlow, Bellevue, and Dayton. Our overnight shipping labels work from any UPS location, so your location on either side of the river doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Covington?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Covington?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Covington, Newport, and Florence offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Covington?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Covington?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Kenton County families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Covington", address: "25 W 5th St, Covington, KY 41011", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Covington", address: "4315 Winston Ave, Covington, KY 41015", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Florence", address: "7625 Doering Dr, Florence, KY 41042", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Newport", address: "415 E 6th St, Newport, KY 41071", hours: "Mon–Sun: 8AM–10PM" },
    { name: "CVS Pharmacy — Florence", address: "6900 Burlington Pike, Florence, KY 41042", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — Erlanger", address: "3100 Dixie Hwy, Erlanger, KY 41018", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Fort Thomas", address: "90 N Fort Thomas Ave, Fort Thomas, KY 41075", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Florence", address: "4990 Houston Rd, Florence, KY 41042", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Circuit Court Clerk — Kenton County",
      address: "303 Court St, Covington, KY 41011",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Driver's license and REAL ID. Appointment recommended.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Campbell County",
      address: "330 York St, Newport, KY 41071",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and driver's license renewals. Online booking available.",
      featured: false,
    },
    {
      name: "Circuit Court Clerk — Boone County",
      address: "2950 Washington St, Burlington, KY 41005",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service center for Boone County residents.",
      featured: true,
    },
    {
      name: "Ohio BMV — Cincinnati",
      address: "5721 Dragon Way, Cincinnati, OH 45227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Alternative for Ohio residents across the river. Walk-ins limited.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International",
      distance: "12 miles from downtown Covington",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "The primary airport for Kenton County and the Northern Kentucky Cincinnati metro area. Domestic and international flights to major hubs worldwide.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Airport",
      featured: true,
    },
    {
      code: "SDF",
      name: "Louisville Muhammad Ali International",
      distance: "100 miles from Covington",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "Alternative regional airport with flights to major hubs.",
      flightUrl: "https://www.flylouisville.com/",
      flightLabel: "Louisville Airport",
      featured: false,
    },
    {
      code: "LEX",
      name: "Blue Grass Airport (Lexington)",
      distance: "85 miles from Covington",
      address: "4000 Terminal Dr, Lexington, KY 40510",
      note: "Alternative regional airport for central Kentucky flights.",
      flightUrl: "https://www.bluegrassairport.com/",
      flightLabel: "Blue Grass Airport",
      featured: false,
    },
  ],
};